import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorHandleService } from './error-handle.service';
import { catchError, Observable } from 'rxjs';
import {
  DetailSalesPercentageResponse,
  DetailSalesResponse,
  DetailSalesRevenueResponse,
  PropertyAvailabilityResponse,
  ResedensialOccupancyResponse,
  ResidencesDetailFacilitiesResponse,
  ResidencesDetailResponse,
  ResidencesDetailSummaryResponse,
  ResidencesResponse,
  SalesMetricResponse,
  SalesPercentageResponse,
  SalesRevenueResponse
} from '../models/residences';
import { environment } from '../../../environments/environment.development';
import { OfficeLeaseOccupancyResponse } from '../models/office-lease';

@Injectable({
  providedIn: 'root'
})
export class ResidencesService {
  private apiUrl = `${environment.APIDEV}`;



  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }


  getListResidences(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<ResidencesResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<ResidencesResponse>(`${this.apiUrl}residence/list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getResidencesDetailFacilities(
    id: string | number,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<ResidencesDetailFacilitiesResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<ResidencesDetailFacilitiesResponse>(`${this.apiUrl}residence/detail/${id}/facilities`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getResidencesDetailSummary(
    id: string | number,
    startDate?: string,
    endDate?: string
  ): Observable<ResidencesDetailSummaryResponse> {

    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<ResidencesDetailSummaryResponse>(`${this.apiUrl}residence/detail/${id}/summarydetail`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesMetric(
    startDate?: string,
    endDate?: string
  ): Observable<SalesMetricResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesMetricResponse>(`${this.apiUrl}residence/sales_metric`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }


  getResidencesDetail(
    id?: number,
    startDate?: string,
    endDate?: string
  ): Observable<ResidencesDetailResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<ResidencesDetailResponse>(`${this.apiUrl}residence/detail/${id}`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesDetail(
    id?: number,
    startDate?: string,
    endDate?: string
  ): Observable<DetailSalesResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DetailSalesResponse>(`${this.apiUrl}residence/detail/${id}/sales`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesDetailRevenue(
    id?: number,
    startDate?: string,
    endDate?: string
  ): Observable<DetailSalesRevenueResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DetailSalesRevenueResponse>(`${this.apiUrl}residence/detail/${id}/sales_revenue`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getResedensialOccupancy(
      id?: number,
      startDate?: string,
      endDate?: string
    ): Observable<ResedensialOccupancyResponse> {
      let params = new HttpParams();
  
      if (startDate) {
        params = params.set('startDate', startDate);
      }
  
      if (endDate) {
        params = params.set('endDate', endDate);
      }
  
      return this.http.get<ResedensialOccupancyResponse>(`${this.apiUrl}residence/detail/${id}/sales_percentage`, {
        params,
        ...this.errorHandle._httpOptions()
      }).pipe(
        catchError(this.errorHandle.errorHandl)
      );
    }

  getResidencePropertyAvailablity(
    startDate?: string,
    endDate?: string
  ): Observable<PropertyAvailabilityResponse> {
    let params = new HttpParams()
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<PropertyAvailabilityResponse>(`${this.apiUrl}residence/property_availablity`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesRevenue(
    startDate?: string,
    endDate?: string
  ): Observable<SalesRevenueResponse> {
    let params = new HttpParams()
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesRevenueResponse>(`${this.apiUrl}residence/sales_revenue`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesPercentage(
    startDate?: string,
    endDate?: string
  ): Observable<SalesPercentageResponse> {
    let params = new HttpParams()
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesPercentageResponse>(`${this.apiUrl}residence/sales_percentage`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
}
